// @tc-check
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

export const StyledListContainer = styled.div`
  height: 238px;
  ${({ isSubMenu }) => isSubMenu && `height: 307px;`}
`;

export const StyledCustomMenuItem = styled.li`
  list-style-type: none;
  padding: 1.5rem;
`;

export const StyledMenu = styled.div`
  ${({ menuWidth, menuWidthExpanded, isSearchMode }) =>
    isSearchMode
      ? `min-width: ${menuWidthExpanded};`
      : `min-width: ${menuWidth};`}
  overflow-y: auto;
  &:not(:last-child) {
    border-right: 1px solid ${getColor('silverSand')};
  }
`;
